module.exports = __webpack_public_path__ + "img/service_img_2.174eee9f.png";